import React from "react";
import { StyleSheet, Pressable } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

interface TabButtonProps {
  title: string;
  isActive: boolean;
  onPress: () => void;
}

const TabButton2: React.FC<TabButtonProps> = ({ title, isActive, onPress }) => (
  <Pressable
    onPress={onPress}
    style={[styles.tabButton, isActive && styles.activeTabButton]}
  >
    <Text
      variant={isActive ? "body_text_2" : "body_text_3"}
      style={[styles.tabButtonText, isActive && styles.activeTabButtonText]}
    >
      {title}
    </Text>
  </Pressable>
);

export default TabButton2;

const styles = StyleSheet.create({
  tabButton: {
    flex: 1,
    paddingVertical: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color.primaryBg,
    marginHorizontal: 6,
    borderRadius: 10,
    paddingHorizontal: 12,
  },
  activeTabButton: {
    backgroundColor: color.mediumBlack,
    color: color.black,
  },
  tabButtonText: {
    color: color.mediumBlack,
  },
  activeTabButtonText: {
    color: color.white,
  },
});
